<template>
  <ul class="list" data-type="list">
    <li
      v-for="(item, i) in list"
      :key="i"
      class="list__item"
    >
      <span class="grid-hide"></span>
      <GameButton
        :data="{
          value: i,
          type: 'list',
          content: item,
        }"
      />
    </li>
  </ul>
</template>

<script>
import GameButton from '@/components/GameButton.vue';

export default {
  name: 'GameList',

  components: {
    GameButton,
  },

  props: {
    structure: {
      type: Object,
      required: true,
    },
  },

  computed: {
    list() {
      return this.$translate('questions')[this.structure.id].answers;
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  position: relative;
  padding: 1px 0 0 1px;

  align-items: flex-start;
  justify-content: space-between;
  flex-flow: column nowrap;

  &,
  .list__item {
    width: 100%;
    display: flex;
  }

  .list__item {
    position: relative;
    flex: 0 0 calc(var(--unit-vh) - 2px);
    height: calc(var(--unit-vh) - 2px);
    align-items: center;
    margin: 1px 0;

    // background-color: $color-bg;

    justify-content: flex-start;

    &:last-child {
      flex: 0 0 calc(var(--unit-vh) - 3px);
      height: calc(var(--unit-vh) - 3px);
    }
  }
}
</style>

<style lang="scss">
.list {
  .list__item:nth-child(1) button svg {
    .svg__outline { stroke: $color-blue; }
    .svg__fill { fill: $color-blue; }
  }
  .list__item:nth-child(2) button svg {
    .svg__outline { stroke: $color-yellow; }
    .svg__fill { fill: $color-yellow; }
  }
  .list__item:nth-child(3) button svg {
    .svg__outline { stroke: $color-red; }
    .svg__fill { fill: $color-red; }
  }
  .list__item:nth-child(4) button svg {
    .svg__outline { stroke: $color-green; }
    .svg__fill { fill: $color-green; }
  }
}
</style>
